import { axiosInstance } from '.'
import { GetBlogsSearchParams } from '../lib/types'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import { CREATE_BLOG, GET_BLOG_BY_ID, GET_BLOGS, UPDATE_BLOG_BY_ID, UPLOAD_FILE } from './endpoints'

export type BlogFormData = {
  title: string
  sub_title: string
  slug: string
  content: string
  banner_image: string
  status: string
  category: string
  linkedin_url?: string | null
  reading_time_minutes?: number | null
}

export const blogServices = {
  getBlogs: async (params: GetBlogsSearchParams) => {
    try {
      const data = await axiosInstance.get(GET_BLOGS, {
        params: removeEmptyValueFromObject(params),
      })
      const blogs = {
        blogs: data.data.blogs,
        pagination: {
          count: data.data.count,
          limit: data.data.limit,
          offset: data.data.offset,
          total: data.data.total,
        },
      } as const
      return blogs
    } catch (error: any) {
      return error.response
    }
  },

  getBlogById: async (id: string) => {
    try {
      const data = await axiosInstance.get(GET_BLOG_BY_ID(id))
      return { data: data.data }
    } catch (error: any) {
      return error.response
    }
  },

  createBlog: async (payload: BlogFormData) => {
    try {
      const res = await axiosInstance.post(CREATE_BLOG, payload)
      return res
    } catch (error: any) {
      return error.response
    }
  },

  updateBlog: async (id: string, payload: BlogFormData) => {
    try {
      return await axiosInstance.patch(UPDATE_BLOG_BY_ID(id), payload)
    } catch (error: any) {
      return error.response
    }
  },

  uploadFile: async (file: File) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      return await axiosInstance.post(UPLOAD_FILE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    } catch (error: any) {
      return error.response
    }
  },
}
